export default __webpack_public_path__ + "static/media/nucorLogoWhite.bcccb44c.svg";